import React, { Component, PropTypes } from 'react';
import {
	injectStripe,
	CardNumberElement,
	CardExpiryElement,
	CardCVCElement,
 } from 'react-stripe-elements';
// import { Link } from 'react-router';
// import { accountRoute } from '../../../routes';
import baseUrl from '../../../utils/baseUrl';

import { dispatchError } from '../../../actions/errors';
import axios from 'axios';
import qs from 'qs';

import ContentBlock from '../block/content';

import Form from '../../form/form';
import InputText from '../../form/input/text';
import InputSubmit from '../../form/input/submit';
import Select from '../../form/select/select';
import Label from '../../form/label';

import FormFitter from '../../form/decorators/formfitter';

import GenericStep from './stepGeneric';

import cc1 from './cc1.png';
import cc2 from './cc2.png';
import cc3 from './cc3.png';
import cc4 from './cc4.png';

import StripeLoader from '../../../utils/stripe';

const CC_VISA = 'CC_VISA';
const CC_ELECTRON = 'CC_ELECTRON';
const CC_MASTERCARD = 'CC_MASTERCARD';
const CC_DISCOVER = 'CC_DISCOVER';
const CC_AMEX = 'CC_AMEX';

const MODE_NEUTRAL = 'MODE_NEUTRAL';
const MODE_CREDITCARD = 'MODE_CREDITCARD';
const MODE_PAYPAL = 'MODE_PAYPAL';

const PAYPAL_AUTH_COMPLETE = 'PAYPAL_AUTH_COMPLETE';
const PAYPAL_AUTH_FAILED = 'PAYPAL_AUTH_FAILED';
const JOB_SAVE_FAILED = 'JOB_SAVE_FAILED';

const createOptions = () => {
	return {
		style: {
			base: {
				fontSize: '14px',
				color: '#8e8e8e',
				letterSpacing: '0.025em',
				fontFamily: 'Good Pro, sans-serif',
				fontWeight: 300,
			},
			invalid: {
				color: '#9e2146',
			},
		},
	};
};

class AccountJobCreateStep3 extends Component {
	static propTypes = {
		activeStep: PropTypes.number.isRequired,
		onSubmit: PropTypes.func.isRequired,
	};

	static defaultProps = {
		active: false,
		onSubmit: function(promise) { promise.then(() => {}).catch(() => {}); },
	};

	constructor(props) {
		super();

		this._receiveMessage = this._receiveMessage.bind(this);
		this.stripe = new StripeLoader();

		this.state = {
			submitting: false,
			mode: MODE_CREDITCARD,
			ccno: '',
			errors: {
				validExpiry: true,
				validCVC: true,
				validCC: true,
			}
		};
	}

	componentWillMount() {}

	componentWillReceiveProps(nextProps) {}

	render() {
		return (
			<GenericStep
				active={(this.props.activeStep === 3)}
				stepNumber='03'
				stepTitle='Payment'
			>

				{(this.state.mode === MODE_NEUTRAL) && this.renderChoosePayment()}

				{(this.state.mode === MODE_CREDITCARD) && this.renderCCForm()}
			</GenericStep>
		);
	}

	renderChoosePayment() {
		return (
			<ContentBlock title='Pay with credit/debit card' smallAside={true}>
					<Label label='Select payment method'></Label>

					<div className='payment-selection'>
						<button className='button button--dark' onClick={() => { this.setState({ ...this.state, mode: MODE_CREDITCARD }); }}>
							Pay with credit/debit card
						</button>

						{/*<button className='button button--light' onClick={this.checkoutWithPaypal.bind(this)}>
							Check out with <img {...paypal} style={{ marginBottom: '-3px' }} />
						</button>*/}
					</div>
			</ContentBlock>
		);
	}

	checkoutWithPaypal() {
		window.open('/api/paypal/job', '_blank');
		window.addEventListener('message', this._receiveMessage, false);
	}

	_receiveMessage(event) {
		if (typeof event.data !== 'string') {
			return false;
		}

		switch (event.data) {
			case PAYPAL_AUTH_COMPLETE:
				this.props.goForward();
				break;
			case JOB_SAVE_FAILED:
				this.props.dispatch(dispatchError({ message: 'Could not save your project - data is corrupt' }));
				break;
			case PAYPAL_AUTH_FAILED:
			default:
				this.props.dispatch(dispatchError({ message: 'Paypal payment failed.' }));
		}

		window.removeEventListener('message', this._receiveMessage);
	}

	renderCCForm() {
		let path = '/api/account/jobs/create/payment';
		let smallAside = true;

		let expireMonths = [
			{ label: '01', value: '01' },
			{ label: '02', value: '02' },
			{ label: '03', value: '03' },
			{ label: '04', value: '04' },
			{ label: '05', value: '05' },
			{ label: '06', value: '06' },
			{ label: '07', value: '07' },
			{ label: '08', value: '08' },
			{ label: '09', value: '09' },
			{ label: '10', value: '10' },
			{ label: '11', value: '11' },
			{ label: '12', value: '12' },
		];

		let expireYears = (() => {
			let years = [];
			let currentYear = new Date().getFullYear();

			for (let yearCount = currentYear; yearCount <= currentYear + 20; yearCount++) {
				years.push({ label: yearCount.toString(), value: yearCount.toString() });
			}

			return years;
		})();

		let cardType = this.detectCardType(this.state.ccno);

		return (
			<Form getRefs={() => this.getRefs()} action={path} smallAside={smallAside} noFun={true} disableAjaxSubmit={true} onSubmit={this.stripeSubmit.bind(this)}>
				<ContentBlock title='Information' smallAside={smallAside}>
					<FormFitter className='span3 span5-tablet span11-mobile'>
						<InputText ref='name' name='name' label='Card holder' placeholder='Name of card holder' />
						<div className="stripe-input">
							<CardNumberElement {...createOptions()} />
						</div>
						<div className="stripe-input">
							<CardExpiryElement {...createOptions()} />
						</div>
						<div className="stripe-input">
							<CardCVCElement {...createOptions()} />
						</div>
					</FormFitter>

				</ContentBlock>

				<ContentBlock className='pixel-pattern pixel-pattern--01' smallAside={smallAside}>
					<div className='span100p'>
						<div className='account-process__button-area'>
							<InputSubmit name='Complete payment' className='button--dark' disabled={this.state.submitting} waiting={this.state.submitting}></InputSubmit>
							<span className='account-process__button-area__button-desc'>Complete payment using your credit/debit card.</span>
						</div>
					</div>
				</ContentBlock>
			</Form>
		);
	}

	stripeSubmit(promise) {
		let token;
		axios.get(baseUrl + '/api/stripe/paymentintent?type=job').then((res) => {
			const chargePromise = new Promise((resolve, reject) => {
				promise.then(() => {
					this.props.stripe.createPaymentMethod('card')
					.then(({ paymentMethod }) => {
					});
					this.props.stripe.createToken().then((response) => {
						token = response.token;
					});
					this.props.stripe.handleCardPayment(res.data.intent_secret).then((result) => {
						if (result.error) {
							this.setState({
								...this.state,
								submitting: false,
							});
							return;
						}

						const API_STRIPE_COMPLETE = '/api/stripe/complete';
						axios.post(baseUrl + API_STRIPE_COMPLETE, qs.stringify({
							type: 'job',
							stripeToken: token.id,
							id: result.paymentIntent.id,
						}));

						// Make API call to populate order to add email
						this.setState({
							...this.state,
							submitting: false,
						});
						resolve();
					}).catch(() => {
						this.setState({
							...this.state,
							submitting: false,
						});
					});
				}).catch((res) => {
					this.setState({
						...this.state,
						submitting: false,
					});
				});
			});

			this.setState({
				...this.state,
				submitting: true,
			});

			chargePromise.then(() => {}).catch(() => {
				this.setState({
					...this.state,
					submitting: false,
				});
			});

			return this.props.onSubmit(chargePromise);
		});
	}

	stripeResponseHandler(status, response, res, resolve, reject) {
		if (response.error) {
			this.props.dispatch(dispatchError(response.error));
			reject(response);
		} else {
			let token = response.id;
			let API_STRIPE_CHARGE = '/api/stripe/charge';

			axios.post(baseUrl + API_STRIPE_CHARGE, qs.stringify({
				stripeToken: token,
				type: 'job',
			}))
			.then(apiRes => {
				this.setState({
					...this.state,
					submitting: false,
				});

				resolve(apiRes.data);
			})
			.catch(apiRes => {
				if (apiRes.data && apiRes.data.message) {
					this.props.dispatch(dispatchError(apiRes.data));
				}

				this.setState({
					...this.state,
					submitting: false,
				});

				reject(apiRes);
			});
		}
	}

	getRefs() {
		return this.refs;
	}

	detectCardType(number) {
		number = number.replace(/[^0-9.]/g, '');

		var re = {
			electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
			maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
			dankort: /^(5019)\d+$/,
			interpayment: /^(636)\d+$/,
			unionpay: /^(62|88)\d+$/,
			visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
			mastercard: /^5[1-5][0-9]{14}$/,
			amex: /^3[47][0-9]{13}$/,
			diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
			discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
			jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
		};

		if (re.electron.test(number)) {
			return CC_ELECTRON;
		}  else if (re.visa.test(number)) {
			return CC_VISA;
		} else if (re.mastercard.test(number)) {
			return CC_MASTERCARD;
		} else if (re.amex.test(number)) {
			return CC_AMEX;
		} else {
			return undefined;
		}
	}
}

export default injectStripe(AccountJobCreateStep3);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jobCreate/step3.js
 **/